module.exports = __webpack_public_path__ + "static/media/boy-12.e6c6f95b.svg";